export default __webpack_public_path__ + "static/media/logo-digitalocean.a1f147b0.svg";